module.exports = __webpack_public_path__ + "static/fonts/Suiguanjia-Medium.3fc54d2.otf";


//////////////////
// WEBPACK FOOTER
// ./static/font/Suiguanjia-Medium.otf
// module id = 137
// module chunks = 8